<script setup lang="ts">
import { useModalStore } from '../../store/modal';

defineProps({
    reverse: {
        type: Boolean,
        default: false
    }
})
const modalStore = useModalStore();
</script>

<template>
<div class="action-modal" :class="{'--reverse': reverse}">
    <div class="action-modal-buttons">
        <slot />
    </div>
    <button class="action-modal-close-button" @click.prevent="modalStore.close()">
        <ah-icon name="cross-default" :size="20"/>
    </button>
</div>
</template>

<style lang="scss">
.action-modal {
    position: absolute!important;
    top: 1rem;
    right: 6.6rem;
    width: 28.6rem;
    padding: 1rem;
    height: 10.5rem;
    background: var(--color-red-raspberry);
    border-radius: 2.4rem;
    display: flex;
    gap: 1rem;
    justify-content: flex-start;

    .action-modal-buttons {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 1rem;

        button {
            height: 4rem;
            width: 100%;
            background: var(--color-black-20);
            border: none;
            outline: none;
            border-radius: 2.4rem;
            text-align: center;
            @include font(1.4,1.4,black);
            color: var(--color-white);

            &:hover {
                background: var(--color-black-40);
            }
        }
    }

    .action-modal-close-button {
        width: 4.6rem;
        height: 4.6rem;
        background: var(--color-black-20);
        border: .6rem solid var(--color-white-20);
        outline: none;
        border-radius: 50%;
        position: relative;

        .icon {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 2rem;
            height: 2rem;
            fill: var(--color-white);
            z-index: 999;
        }

        &:hover {
            background: var(--color-black-40);
            border-color: var(--color-white-40);
        }
    }

    &.--reverse {
        flex-direction: row-reverse;

        .action-modal-close-button {
            align-self: flex-end;
        }
    }
}
</style>
